<div class="d-flex flex-column gap-3 m-4">
  <app-history-item *ngFor="let item of history$ | async" [description]="item.event" [date]="item.eventDate" />
</div>
